export default __webpack_public_path__ + "static/media/tools_white.af3a476f.svg";